import React, { useContext, useState } from 'react';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import { t } from '../../../types/translation/Translator';
import { CompanyContext } from '../../../context/CompanyContext';
import { Icon } from '../../icons';
import { IconType } from '../../icons/Icon';
import { Dropdown, DropdownList } from '../Dropdown';
import { Company } from '../../../types/company';
import { FileViewLoader } from '../../../VentoryUI/components/common/File';
import { FileEntityType } from '../../../types/file';
import { ReactComponent as VentoryWhiteLogo } from '../../../assets/img/Ventory-WhiteNoBack.svg';
import { VentoryColor } from '../../../VentoryUI/util/color.util';
import { storeCurrentCompanyId } from '../../../util/token.util';
import { useNavigate } from 'react-router-dom';
import { CompanyConnectionContext } from '../../../context/CompanyConnectionContext';

export default function HeaderPartnerMenu() {
  const navigate = useNavigate();

  const { currentCompany, companies, refreshCompany } = useContext(CompanyContext);
  const { companyConnections } = useContext(CompanyConnectionContext);

  const [open, setOpen] = useState(false);

  const connections = new Set(
    [...Array.from(companyConnections.values())]
      .filter(cc => cc.parentId === currentCompany.id || cc.companyId === currentCompany.id)
      .map(cc => [cc.companyId, cc.parentId])
      .flat(),
  );

  const [items, setItems] = useState(
    Array.from(companies.values())
      .filter(c => c.companyId !== currentCompany.companyId && connections.has(c.id))
      .sort((a, b) => (b.partner ? 1 : 0) - (a.partner ? 1 : 0)),
  );

  const logo = (company: Company) => {
    if (company.settings.companyLogo) {
      return (
        <FileViewLoader
          className='object-scale-down'
          companyId={company.id}
          fileId={company.settings.companyLogo}
          fileEntityType={FileEntityType.company}
        />
      );
    } else {
      return <VentoryWhiteLogo color={VentoryColor.grey500} stroke={VentoryColor.grey500} />;
    }
  };

  return (
    <div
      className='flex h-full items-center'
      style={{
        borderColor: currentCompany.settings.accentColor || currentCompany.settings.primaryColor,
        borderBottomWidth: '2px',
      }}
    >
      <Dropdown
        open={open}
        setOpen={setOpen}
        width={'360px'}
        additionalOffsetTop={10}
        dropdown={
          <DropdownList
            items={items}
            textBuilder={item => item.name}
            itemBuilder={item => (
              <div className='flex-cols flex h-[40px] select-none items-center gap-4'>
                <div className='h-[40px] w-24 justify-start' style={{ backgroundColor: item.settings.headerColor }}>
                  {logo(item)}
                </div>
                <p className='text-title'>{item.name}</p>
              </div>
            )}
            onClick={item => {
              storeCurrentCompanyId(item.id);
              refreshCompany(item.id);
              navigate('/dashboard');
            }}
          />
        }
      >
        <div className='flex h-full select-none items-center hover:cursor-pointer' onClick={() => setOpen(!open)}>
          <div className='min-w-[136px]'>
            <p className='text-sm font-semibold'>{t(TranslationKey.partnerPortal).singular.label}</p>
            <p className='text-xs' style={{ color: currentCompany.settings.accentColor }}>
              {currentCompany.name}
            </p>
          </div>
          <div className='ml-4'>
            <Icon type={IconType.chevronDown} stroke='stroke-accent' />
          </div>
        </div>
      </Dropdown>
    </div>
  );
}
